import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { TaxaJurosMaximaAgenteService } from 'src/app/shared/services/taxa-juros-maxima-agente.service';
import { Tranche } from 'src/app/model/tranche.model';
import { TrancheService } from 'src/app/shared/services/tranche.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TaxaJurosMediaMaximaAgenteService } from 'src/app/shared/services/taxa-juros-media-maxima-agente.service';
import { JanelaApuracaoTaxaMediaMaximaAgente } from 'src/app/model/janela-apuracao-taxa-media-maxima-agente';
import { JanelaApuracaoService } from 'src/app/shared/services/janela-apuracao.service';
import { TaxaJurosMediaMaximaAgente } from 'src/app/model/taxa-juros-media-maxima-agente.model';
import { MensagemService } from '../../mensagem.service';

@Component({
    selector: 'app-taxa-juros-media-agente-pesquisa',
    templateUrl: './taxa-juros-media-agente-pesquisa.component.html',
    styleUrls: ['./taxa-juros-media-agente-pesquisa.component.scss'],
    standalone: false
})
export class TaxaJurosMediaAgentePesquisaComponent implements OnInit {

    //formulario Parametros
    private ideTranche: number;
    private ideJanelaApuracao: number;
    private compararComTaxaMaxima: boolean;
    private agenteFinanceiro: AgenteFinanceiro;

    private cnpjUsuario: string;
    private agentesFinanceiros: AgenteFinanceiro[] = [];
    private podeEscolherAgente: boolean;

    private pesquisado: boolean;

    private tranches: Tranche[];
    private janelas: JanelaApuracaoTaxaMediaMaximaAgente[] = [];
    private todasJanelas: JanelaApuracaoTaxaMediaMaximaAgente[] = [];
    private taxas: TaxaJurosMediaMaximaAgente[] = [];

    private pesquisaForm: UntypedFormGroup;


    constructor(private permissaoService: PermissaoService,
        private formBuilder: UntypedFormBuilder,
        private bnUsuarioService: BnUsuarioService,
        private activatedRoute: ActivatedRoute,
        private trancheService: TrancheService,
        private mensagemService: MensagemService,
        private taxaJurosMediaMaximaAgenteService: TaxaJurosMediaMaximaAgenteService,
        private janelaService: JanelaApuracaoService) {
    }

    @HostListener('window:keydown.enter', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (this.pesquisaForm.valid) {
            this.buscar();
        }
    }

    public ngOnInit() {
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {

            this.podeEscolherAgente = resp && (resp[ROLE_GESTOR_CONSULTA] || resp[ROLE_GESTOR_ENVIO]);
        });
        this.bnUsuarioService.usuario$.subscribe(usuario => {

            this.cnpjUsuario = usuario && usuario.cnpj;
        });

        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes']; //resolver

        this.janelaService.buscarJanelasApuracao().subscribe(janelas => {
            this.todasJanelas = janelas;
            this.janelas = this.todasJanelas;
        })

        this.trancheService.getTranches().subscribe(tranches => {
            this.tranches = tranches;
        });
        this.pesquisado = undefined;
        this.construirFormulario();
    }

    construirFormulario() : void {
        this.pesquisaForm = this.formBuilder.group({
            ideTranche: ['', Validators.required],
            agenteFinanceiro: [null, []],
            ideJanelaApuracao: [null],
            compararComTaxaMaxima: [false],
        });
        this.pesquisaForm.get("ideJanelaApuracao").disable();
        this.alteracoesFormulario();
    }

    alteracoesFormulario() : void {
        const formTranche = this.pesquisaForm.get("ideTranche");
        const formJanela = this.pesquisaForm.get("ideJanelaApuracao");
        const formAgenteFinanceiro = this.pesquisaForm.get("agenteFinanceiro");

        formTranche.valueChanges.subscribe(trancheNova => {
            if (trancheNova) {
                this.janelas = this.todasJanelas.filter(j => j.ideTranche == trancheNova);                
                formJanela.enable();
                formAgenteFinanceiro.updateValueAndValidity();
            } else if(!trancheNova) {
                formJanela.disable();
                this.janelas = this.todasJanelas;
            }
            formJanela.setValue(null);
        });

        formAgenteFinanceiro.valueChanges.subscribe(agenteNovo => {
            if(agenteNovo || !this.podeEscolherAgente){
                formJanela.setValidators(null);
                formJanela.updateValueAndValidity();
            } else if(!agenteNovo){
                formJanela.setValidators(Validators.required);
                formJanela.markAsDirty();
                formJanela.updateValueAndValidity();
            }
        });
    }
    limpar(): void {
        this.compararComTaxaMaxima = false;
        this.ideTranche = undefined;
        this.ideJanelaApuracao = undefined;
        if (this.podeEscolherAgente) {
            this.agenteFinanceiro = undefined;
            this.pesquisaForm.get('agenteFinanceiro').reset();
            this.pesquisaForm.reset();
        }
        this.pesquisado = undefined;

        this.pesquisaForm.get('ideJanelaApuracao').reset();
        this.pesquisaForm.get('ideTranche').reset();
        this.pesquisaForm.get('compararComTaxaMaxima').reset();
        this.pesquisaForm.updateValueAndValidity();
    }


    atualizarCompararComTaxaMaxima(): void {
        this.compararComTaxaMaxima = !this.compararComTaxaMaxima;
    }

    atualizarFormulario(): void {
        this.ideJanelaApuracao = this.pesquisaForm.get("ideJanelaApuracao").value;
        this.ideTranche = this.pesquisaForm.get("ideTranche").value;
        this.compararComTaxaMaxima = this.pesquisaForm.get("compararComTaxaMaxima").value;
        const cnpjAgenteFinanceiro = this.pesquisaForm.get("agenteFinanceiro").value;
        if (this.podeEscolherAgente) {
            this.agenteFinanceiro = this.agentesFinanceiros.filter(agente => agente.cnpj === cnpjAgenteFinanceiro)[0];
        }
        else {
            this.agenteFinanceiro = this.agentesFinanceiros.filter(agente => agente.cnpj === this.cnpjUsuario)[0];
        }
    }

    getParams() : any {
        const params: any = {};
        if (this.agenteFinanceiro && this.agenteFinanceiro.id != null) {
            params.ideAgenteFinanceiro = this.agenteFinanceiro.id;
        }
        if (this.ideJanelaApuracao) {
            params.ideJanelaApuracao = this.ideJanelaApuracao;
        }
        return params;
    }

    buscar(): void {
        this.atualizarFormulario();
        this.pesquisado = false;
        if (this.pesquisaForm.get("ideTranche").value) {
            const params = this.getParams();
            this.taxaJurosMediaMaximaAgenteService.buscarTaxaMediaMaxima(this.ideTranche, params).subscribe(taxas => {
                this.taxas = taxas;
                this.pesquisado = true;
            });
        }
    }

    compararPorId(item1: string, item2: string): boolean {

        if (item1 && item2) {
            return item1 === item2;
        }
        if (!item1 && !item2) {
            return true;
        }
        return false;
    }
}
